import React, { memo } from 'react';
import { FaRubleSign } from 'react-icons/fa';
import formatNumber from '../../utils/formatNumber';
import getDiscount from '../../utils/getDiscount';
import moment from 'moment';
import s from './OneHotTourViewForHotToursWidget.module.css';
import { HotTourRating } from '../../components/HotTourRating';
import { Link } from 'react-router-dom';

export const OneHotTourViewForHotToursPage = memo(
  ({ tour, discount, GLOBAL = [], idx }) => {
    tour.volatility = 0;

    const discountTour = getDiscount(
      {
        depart: tour.departurecode,
        country: tour.countrycode,
        oper: tour.operatorcode,
        region: tour.regioncode,
        subregion: tour.subregioncode,
        hotel: tour.hotelcode,
        child: 0,
        meal: tour.mealcode,
        dt: tour.flydate,
        currency: tour.currency,
      },
      discount
    );

    if (discountTour && discountTour.active) {
      if (discountTour.proc > 0) {
        tour.price = Math.ceil((tour.price * (100 - discountTour.proc)) / 100);
        tour.hot_price = Math.ceil(
          (tour.hot_price * (100 + discountTour.proc)) / 100
        );
      } else if (discountTour.currency_discount > 0) {
        tour.price = tour.price - discountTour.currency_discount;
        if (tour.hot_price > 0) {
          tour.hot_price =
            tour.hot_price - Math.ceil(discountTour.currency_discount / 2);
        }
      }
      tour.text = discountTour.text;
      tour.discount = true;
    }

    if (
      tour.price &&
      tour.priceold &&
      parseInt(tour.priceold) > parseInt(tour.price)
    ) {
      tour.volatility = 100 - Math.round((tour.price / tour.priceold) * 100);
    }

    tour.priceoldFormatted = formatNumber(tour.priceold);
    tour.priceFormatted = formatNumber(tour.price);

    return (
      <article className={s.tourCard}>
        <section
          onClick={() => {
            GLOBAL.gt.getHotelInfo(tour.hotelcode);
          }}
          className={s.imageSection}
        >
          <b className={s.volatility}>-{tour.volatility}%</b>
          <div className={s.rating}>
            <HotTourRating hotelstars={tour.hotelstars} />
          </div>
          <img
            className={s.tourHotelImage}
            src={tour.hotelpicture.replace('small', 'medium')}
            alt={`Фото отеля ${tour.hotelname}`}
            onError={(e) => {
              e.target.src = `https://static.tourvisor.ru/hotel_pics/medium/hotel_country_${tour.countrycode}.jpg`;
            }}
            loading="lazy"
          />
        </section>
        <section className={s.tourInfo}>
          <span className={s.hotelName} title={tour.hotelcode}>
            {tour.hotelname}
          </span>
          <div className={s.tourLocation}>
            {tour.countryname}
            {tour.hotelregionname ? `, ${tour.hotelregionname}` : ''}
          </div>
          <div>
            <span className={s.departArrive}>
              вылет {moment(tour.flydate, 'DD.MM.YYYY').format('DD.MM')} на{' '}
              <b>{tour.nights} ночей</b>
            </span>
          </div>
        </section>
        <section>
          <Link
            to={`https://www.geograftour.com/tours/tour-info/${tour.tourid}/`}
            target="_blank"
            className={s.link}
          >
            <span className={s.priceDescription}>За 1 человека</span>
            <span className={s.oldPrice}>{tour.priceoldFormatted}</span>
            <span className={s.hotelPrice}>
              {tour.priceFormatted}
              <FaRubleSign className={s.priceCurrency} />
            </span>
          </Link>
        </section>
      </article>
    );
  }
);
